var addButtons = document.querySelectorAll('[data-sunday-reading-add]');

function addSubscription(variantID,subscriptionID) {

    let formData = {
        'id': variantID,
        'selling_plan': subscriptionID,
        'quantity': 1
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
        var refreshCart = new CustomEvent('apps:product-added-to-cart');
        document.dispatchEvent(refreshCart);
        document.querySelector('[data-js-cart-icon]').click();
    })
    .catch((error) => {
      console.log(error);
    });
  }

for (let i = 0; i < addButtons.length; i++) {
    addButtons[i].addEventListener("click", function(e) {
        let variantID = e.target.dataset.variant;
        let subscriptionID = e.target.dataset.subscribe;
        addSubscription(variantID,subscriptionID)
    });
}